// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class LongValue implements flatbuffers.IUnpackableObject<LongValueT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): LongValue {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsLongValue(bb: flatbuffers.ByteBuffer, obj?: LongValue): LongValue {
    return (obj || new LongValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsLongValue(bb: flatbuffers.ByteBuffer, obj?: LongValue): LongValue {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new LongValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : 0n;
  }

  static startLongValue(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, value: bigint) {
    builder.addFieldInt64(0, value, 0n);
  }

  static endLongValue(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createLongValue(builder: flatbuffers.Builder, value: bigint): flatbuffers.Offset {
    LongValue.startLongValue(builder);
    LongValue.addValue(builder, value);
    return LongValue.endLongValue(builder);
  }

  unpack(): LongValueT {
    return new LongValueT(this.value());
  }

  unpackTo(_o: LongValueT): void {
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): LongValueT {
    const t = new LongValueT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class LongValueT implements flatbuffers.IGeneratedObject {
  constructor(public value: bigint = 0n) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return LongValue.createLongValue(builder, this.value);
  }

  clone(): LongValueT {
    const obj = new LongValueT();
    obj.value = this.value;
    return obj;
  }

  equals(other: LongValueT): boolean {
    if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyLongValue(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 8);
  } finally {
    verifier.popDepth();
  }
}
